import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import Aliquots from "../components/finance/Aliquots";
import CreateAliquot from "../components/finance/CreateAliquot";
import EditAliquot from "../components/finance/EditAliquot";

const AliquotsLayout = () => {
    const { selectedCondominium } = useSelector((state) => state.condominium);

    return (
        <Switch>
            <Route path="/dashboard/aliquots" exact>
                {selectedCondominium ? (
                    <Redirect to={`/dashboard/finance/${selectedCondominium}/aliquots`} />
                ) : (
                    <Redirect to="/dashboard/condominiums" />
                )}
            </Route>
            <Route
                path="/dashboard/finance/:id/aliquots"
                exact
                component={Aliquots}
            />
            <Route
                path="/dashboard/finance/:id/aliquots/create"
                component={CreateAliquot}
            />
            <Route
                path="/dashboard/finance/:id/aliquots/edit/:aliquotId"
                component={EditAliquot}
            />
        </Switch>
    );
};

export default AliquotsLayout;
